var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueDate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 2.479H19.5C19.7652 2.479 20.0196 2.58436 20.2071 2.7719C20.3946 2.95943 20.5 3.21379 20.5 3.479V19.479C20.5 19.7442 20.3946 19.9986 20.2071 20.1861C20.0196 20.3736 19.7652 20.479 19.5 20.479H1.5C1.23478 20.479 0.98043 20.3736 0.792893 20.1861C0.605357 19.9986 0.5 19.7442 0.5 19.479V3.479C0.5 3.21379 0.605357 2.95943 0.792893 2.7719C0.98043 2.58436 1.23478 2.479 1.5 2.479H5.5V0.479004H7.5V2.479H13.5V0.479004H15.5V2.479ZM13.5 4.479H7.5V6.479H5.5V4.479H2.5V8.479H18.5V4.479H15.5V6.479H13.5V4.479ZM18.5 10.479H2.5V18.479H18.5V10.479Z",
    fill: "#1C9FDA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueDate);
export default __webpack_public_path__ + "static/media/blue_date.e4819ff82518f3dd78c31e1170438cc8.svg";
export { ForwardRef as ReactComponent };